import React from "react";
import { Link } from "react-router-dom";
import FixMenu from "../components/FixMenu";
import Header from "../components/Header";

const SupplyRelatedComaplaint = () => {
  return (
    <>
      <div id="bodyaddid">
        <Header />
        <FixMenu />
        <section className="consumer_inner_bg">
          <img src="assets/images/supply-related-banner.jpg" />
          <div className="container-fluid">
            <div className="apply_title">
              <h1>Supply Related Complaint</h1>
            </div>
          </div>
        </section>
        <section className="main_sectiods">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 brdcum_designs">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="#">Home</Link>
                    <span className="icondsds">
                      <i className="fa fa-chevron-right" aria-hidden="true"></i>
                    </span>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/consumer-portal">Consumer Portal</Link>
                    <span className="icondsds">
                      <i className="fa fa-chevron-right" aria-hidden="true"></i>
                    </span>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/register-complain">Register a Complaint</Link>
                    <span className="icondsds">
                      <i className="fa fa-chevron-right" aria-hidden="true"></i>
                    </span>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/supply-related-comaplaint" className="active">
                      Supply Related Complaint
                    </Link>
                  </li>
                </ol>
              </div>
            </div>
            <div className="row justify-content-center padtops">
              <div className="col-sm-12">
                <div className="row">
                  <div className="col-sm-12 bg_cols">
                    <div className="form_div wrapper-pd-top-login">
                      <div className="bs-example bs-example-1">
                        <div
                          className="tab-pane fade show active"
                          id="newconnection"
                        >
                          <div className="innerhdnds">
                            <h2>Supply Related Complaint</h2>
                          </div>
                          <ul className="nav nav-tabs nav_tbds" style={{overflow:"hidden"}}>
                            <li className="nav-item">
                              <Link
                                to="/supply-related-comaplaint"
                                className="nav-link active"
                                data-toggle="tab"
                              >
                                Planned Outages
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to="/register"
                                className="nav-link"
                                data-toggle="tab"
                              >
                                Register
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to="/status"
                                className="nav-link"
                                data-toggle="tab"
                              >
                                Status
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to="/feedbackform"
                                className="nav-link"
                                data-toggle="tab"
                              >
                                Feedback
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to="/complaintmanagementprocess"
                                className="nav-link"
                                data-toggle="tab"
                              >
                                Complaint Management Process (Guide)
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to="/faqs"
                                className="nav-link"
                                data-toggle="tab"
                              >
                                FAQs
                              </Link>
                            </li>
                          </ul>
                        </div>{" "}
                      </div>
                      <div className="tab-content tab_main">
                        <div
                          className="tab-pane cashcollectioncenter fade show active"
                          id="checklist"
                        >
                          <h4 className="mt-2">Industrial </h4>

                          <div className="innwrper">
                            <h5>Area Affected</h5>
                            <p>
                              NATIONAL DATA CENTRE,SUMITRA NURSHING,ST FRANSIS
                              SCHOOL,STREET LIGHT ,NEW VISION EDUCATION
                              SOCIETY,NIDP DEVELOPERS
                            </p>
                          </div>

                          <div className="innwrper">
                            <p>
                              <b>From:</b> 15/1/2022,11:00 hrs
                            </p>
                            <p>
                              <b>To:</b> 15/1/2022,13:30 hrs
                            </p>
                            <p>
                              <b>Remarks:</b> Supply interruption due to planned
                              shutdown of electric network from 11:00 hrs,
                              15-Jan-22. Expected time of restoration 13:30 hrs,
                              15-Jan-22.-NPCL
                            </p>
                          </div>

                          <div className="innwrper">
                            <h5>Area Affected</h5>
                            <p>
                              HRA, SITE-C RESIDENTIAL, NPCL SITE-C STORE, ATS
                              SOCIETY, JANATA FLTAS, INDUS TOWER, HRA-9, EHOMES,
                              MAHALAXMI SOCIETY
                            </p>
                          </div>

                          <div className="innwrper">
                            <p>
                              <b>From:</b> 16/1/2022,11:00 hrs
                            </p>
                            <p>
                              <b>To:</b> 16/1/2022,16:00 hrs
                            </p>
                            <p>
                              <b>Remarks:</b> Supply interruption due to planned
                              shutdown of electric network from 11:00 hrs,
                              16-Jan-22. Expected time of restoration 16:00 hrs,
                              16-Jan-22.-NPCL
                            </p>
                          </div>
                          <h4 className="mt-2">Institutional </h4>
                          <div className="innwrper">
                            <h5>No Outage Available</h5>
                          </div>

                          <h4 className="mt-2">Township </h4>
                          <div className="innwrper">
                            <h5>Area Affected</h5>
                            <p>
                              NATIONAL DATA CENTRE,SUMITRA NURSHING,ST FRANSIS
                              SCHOOL,STREET LIGHT ,NEW VISION EDUCATION
                              SOCIETY,NIDP DEVELOPERS
                            </p>
                          </div>

                          <div className="innwrper">
                            <p>
                              <b>From:</b> 15/1/2022,11:00 hrs
                            </p>
                            <p>
                              <b>To:</b> 15/1/2022,13:30 hrs
                            </p>
                            <p>
                              <b>Remarks:</b> Supply interruption due to planned
                              shutdown of electric network from 11:00 hrs,
                              15-Jan-22. Expected time of restoration 13:30 hrs,
                              15-Jan-22.-NPCL
                            </p>
                          </div>

                          <div className="innwrper">
                            <h5>Area Affected</h5>
                            <p>
                              HRA, SITE-C RESIDENTIAL, NPCL SITE-C STORE, ATS
                              SOCIETY, JANATA FLTAS, INDUS TOWER, HRA-9, EHOMES,
                              MAHALAXMI SOCIETY
                            </p>
                          </div>

                          <div className="innwrper">
                            <p>
                              <b>From:</b> 16/1/2022,11:00 hrs
                            </p>
                            <p>
                              <b>To:</b> 16/1/2022,16:00 hrs
                            </p>
                            <p>
                              <b>Remarks:</b> Supply interruption due to planned
                              shutdown of electric network from 11:00 hrs,
                              16-Jan-22. Expected time of restoration 16:00 hrs,
                              16-Jan-22.-NPCL
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>{" "}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SupplyRelatedComaplaint;
